import { Routes } from '@angular/router';
import { accessGuard } from '@shared/guards/access.guard';
import { guestGuard } from '@shared/guards/guest.guard';

const MainLayoutRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layout/main-layout/main-layout.component').then((c) => c.MainLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/home/home.component').then((c) => c.HomeComponent),
      },
      {
        path: 'search',
        loadComponent: () =>
          import('./pages/search/search.component').then((c) => c.SearchComponent),
      },
      {
        path: 'preparation',
        loadComponent: () =>
          import('./pages/preparation/preparation.component').then((m) => m.PreparationComponent),
      },
      // {
      //   path: 'events',
      //   loadComponent: () =>
      //     import('./pages/events/events.component').then((m) => m.EventsComponent),
      // },
      // {
      //   path: 'free-contents',
      //   loadComponent: () =>
      //     import('./pages/free-contents/free-contents.component').then(
      //       (m) => m.FreeContentsComponent,
      //     ),
      // },
      {
        path: 'content/:id',
        loadComponent: () =>
          import('./pages/content-details/content-details.component').then(
            (m) => m.ContentDetailsComponent,
          ),
      },
      {
        path: 'news/:id',
        loadComponent: () =>
          import('./pages/news/news-detail/news-detail.component').then(
            (m) => m.NewsDetailComponent,
          ),
      },
      {
        path: 'oauth',
        canActivate: [accessGuard],
        loadComponent: () => import('./pages/oauth/oauth.component').then((m) => m.OauthComponent),
      },
      {
        path: 'live/:descriptor',
        canActivate: [accessGuard],
        loadComponent: () => import('./pages/live-channel/live-channel').then((m) => m.LiveChannel),
      },
      {
        path: 'program/:id',
        loadComponent: () =>
          import('./pages/program-details/program-details.component').then(
            (m) => m.ProgramDetailsComponent,
          ),
      },
      // {
      //   path: 'activity/:id',
      //   loadComponent: () =>
      //     import('./pages/activity-details/activity-details.component').then(
      //       (m) => m.ActivityDetailsComponent,
      //     ),
      // },
      {
        path: 'category/:descriptor',
        loadComponent: () =>
          import('./pages/category/category.component').then((m) => m.CategoryComponent),
      },
      {
        path: 'category/:descriptor/contents',
        loadComponent: () =>
          import('./pages/category/category-contents/category-contents.component').then(
            (m) => m.CategoryContentsComponent,
          ),
      },
      // {
      //   path: 'treasury',
      //   loadComponent: () =>
      //     import('./pages/treasury/treasury.component').then((m) => m.TreasuryComponent),
      // },
      {
        path: 'subscriptions',
        loadComponent: () =>
          import('./pages/subscriptions/subscriptions.component').then(
            (m) => m.SubscriptionsComponent,
          ),
      },
    ],
  },
];

const NoLayoutRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layout/no-layout/no-layout.component').then((c) => c.NoLayoutComponent),
    children: [
      {
        path: 'play/:id',
        canActivate: [accessGuard],
        loadComponent: () =>
          import('./pages/player/player.component').then((c) => c.PlayerComponent),
      },
    ],
  },
];

const AuthLayoutRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layout/authentication-layout/authentication-layout.component').then(
        (c) => c.AuthenticationLayoutComponent,
      ),
    children: [
      // {
      //   canActivate: [guestGuard],
      //   path: 'landing',
      //   loadComponent: () =>
      //     import('./pages/landing/landing.component').then((m) => m.LandingComponent),
      // },
      {
        canActivate: [guestGuard],
        path: 'auth',
        loadComponent: () =>
          import('./pages/authentication/authentication.component').then(
            (m) => m.AuthenticationComponent,
          ),
      },
      {
        canActivate: [guestGuard],
        path: 'auth/device-limit',
        loadComponent: () =>
          import('./pages/authentication/device-limit/device-limit.component').then(
            (m) => m.DeviceLimitComponent,
          ),
      },
      {
        path: 'chat',
        canActivate: [accessGuard],
        loadComponent: () =>
          import('./pages/chatbot-conversations/chatbot-conversations.component').then(
            (m) => m.ChatbotConversationsComponent,
          ),
      },
      {
        path: 'chat/:id',
        canActivate: [accessGuard],
        loadComponent: () =>
          import('./pages/chatbot-conversations/chatbot/chatbot.component').then(
            (m) => m.ChatbotComponent,
          ),
      },
      {
        path: 'personal-info',
        loadComponent: () =>
          import('./pages/register/personal-info/personal-info.component').then(
            (m) => m.PersonalInfoComponent,
          ),
      },

      {
        path: 'profile',
        loadComponent: () =>
          import('./pages/register/profile/profile.component').then((m) => m.ProfileComponent),
      },

      // {
      //   canActivate: [guestGuard],
      //   path: 'auth/google',
      //   loadComponent: () =>
      //     import('./pages/authentication/login-with-google/login-with-google.component').then(
      //       (m) => m.LoginWithGoogleComponent,
      //     ),
      // },
      {
        path: 'register',
        canActivate: [accessGuard],
        loadComponent: () =>
          import('./layout/register-layout/register-layout.component').then(
            (m) => m.RegisterLayoutComponent,
          ),
        children: [
          {
            path: 'personal-info',
            loadComponent: () =>
              import('./pages/register/personal-info/personal-info.component').then(
                (m) => m.PersonalInfoComponent,
              ),
          },
          //     {
          //       path: 'children-info',
          //       loadComponent: () =>
          //         import('./pages/register/children-info/children-info.component').then(
          //           (m) => m.ChildrenInfoComponent,
          //         ),
          //     },
          //     {
          //       path: 'pregnancy-info',
          //       loadComponent: () =>
          //         import('./pages/register/pregnancy-info/pregnancy-info.component').then(
          //           (m) => m.PregnancyInfoComponent,
          //         ),
          //     },
          //     {
          //       path: 'interested-subjects',
          //       loadComponent: () =>
          //         import('./pages/register/interested-subjects/interested-subjects.component').then(
          //           (m) => m.InterestedSubjectsComponent,
          //         ),
          //     },
          //     {
          //       path: 'interested-contents',
          //       loadComponent: () =>
          //         import('./pages/register/interested-contents/interested-contents.component').then(
          //           (m) => m.InterestedContentsComponent,
          //         ),
          //     },
        ],
      },
      {
        path: 'payment/status',
        canActivate: [accessGuard],
        loadComponent: () =>
          import('./pages/payment/payment.component').then((m) => m.PaymentComponent),
      },
    ],
  },
];

const SettingsLayout: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layout/settings-layout/settings-layout.component').then(
        (m) => m.SettingsLayoutComponent,
      ),
    children: [
      {
        path: 'settings',
        canActivate: [accessGuard],
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/settings/settings-landing/settings-landing.component').then(
                (m) => m.SettingsLandingComponent,
              ),
          },
          {
            path: 'devices',
            loadComponent: () =>
              import('./pages/settings/devices/devices.component').then((m) => m.DevicesComponent),
          },
          {
            path: 'subscriptions',
            loadComponent: () =>
              import('./pages/settings/subscriptions/subscriptions.component').then(
                (m) => m.SubscriptionsComponent,
              ),
          },
          {
            path: 'profile',
            loadComponent: () =>
              import('./pages/settings/profile/profile.component').then((m) => m.ProfileComponent),
          },
        ],
      },
      {
        path: 'about-us',
        loadComponent: () =>
          import('./pages/settings/about-us/about-us.component').then((m) => m.AboutUsComponent),
      },
      {
        path: 'faq',
        loadComponent: () =>
          import('./pages/settings/faq/faq.component').then((m) => m.FaqComponent),
      },
      {
        path: 'terms',
        loadComponent: () =>
          import('./pages/settings/terms/terms.component').then((m) => m.TermsComponent),
      },
      {
        path: 'privacy',
        loadComponent: () =>
          import('./pages/settings/privacy/privacy.component').then((m) => m.PrivacyComponent),
      },
      {
        path: 'download',
        loadComponent: () =>
          import('./pages/settings/download/download.component').then((m) => m.DownloadComponent),
      },
      {
        path: 'download/pwa',
        loadComponent: () => import('./pages/pwa/pwa').then((m) => m.Pwa),
      },
    ],
  },
];

const WalletLayoutRoutes: Routes = [
  {
    path: 'wallet',
    loadComponent: () =>
      import('./layout/wallet-layout/wallet-layout.component').then((c) => c.WalletLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/wallet/transactions/transactions.component').then(
            (c) => c.TransactionsComponent,
          ),
      },
      {
        path: 'charge',
        loadComponent: () =>
          import('./pages/wallet/charge/charge.component').then((c) => c.ChargeComponent),
      },
    ],
  },
];

const ErrorLayoutRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layout/error-layout/error-layout.component').then((c) => c.ErrorLayoutComponent),
    children: [
      {
        path: 'error/:statusCode',
        loadComponent: () => import('./pages/error/error.component').then((m) => m.ErrorComponent),
      },
    ],
  },
];

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layout/audio-layout/audio-layout.component').then((c) => c.AudioLayoutComponent),
    children: [
      ...MainLayoutRoutes,
      ...AuthLayoutRoutes,
      ...NoLayoutRoutes,
      ...SettingsLayout,
      ...ErrorLayoutRoutes,
      ...WalletLayoutRoutes,
    ],
  },
  {
    path: '**',
    redirectTo: '/error/404',
  },
];
